const appRouters: Array<any> = [{
    path: '/shipment',
    name: 'shipment',
    sort: 1,
    meta: { title: 'app.Menu.Shipment', showAlways:true,  icon: 'logo-windows' },
    component: () => import('../shared/main/index.vue'),
    children: [
        {
            path: 'declarecustoms', meta: { title: 'app.DeclareCustoms', access: ['RIMS.DeclareCustoms'], icon: '', defaultChild: 'declarecustoms.list' },
            name: 'declarecustoms', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.DeclareCustoms', access: ['RIMS.DeclareCustoms'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.list', component: () => import('./declarecustoms/index.vue'),
                },
                {
                    path: 'add', meta: { title: 'Action.Add', access: ['RIMS.DeclareCustoms.Add'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.add', component: () => import('./declarecustoms/component/create-declare-customs.vue'),
                },
                {
                    path: 'edit', meta: { title: 'Action.Edit', access: ['RIMS.DeclareCustoms.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.edit', component: () => import('./declarecustoms/component/edit-declare-customs.vue'),
                }, 
                {
                    path: 'detail', meta: { title: 'Action.Detail', access: ['RIMS.DeclareCustoms'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.detail', component: () => import('./declarecustoms/component/detail-declare-customs.vue'),
                }, 
                {
                    path: 'invoice', meta: { title: 'app.DeclareCustoms.Invoice', access: ['RIMS.DeclareCustoms.Information'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declareCustoms.invoice', component: () => import('./declarecustoms/component/invoice.vue'),
                },    
                {
                    path: 'packing', meta: { title: 'app.DeclareCustoms.Boxing', access: ['RIMS.DeclareCustoms.Information'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declareCustoms.packing', component: () => import('./declarecustoms/component/packing.vue'),
                },
                {
                    path: 'customslist', meta: { title: 'app.DeclareCustoms.List', access: ['RIMS.DeclareCustoms.Information'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.customslist', component: () => import('./declarecustoms/component/customs-declaration.vue'),
                },
                {
                    path: 'declaregroup', meta: { title: 'app.DeclareCustoms.DeclareGroup', access: ['RIMS.DeclareCustoms.DeclareGroup'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declareCustoms.declareGroup', component: () => import('./declaregroup/index.vue'),
                }, 
                {
                    path: 'copy', meta: { title: 'app.DeclareCustoms.Copy', access: ['RIMS.DeclareCustoms.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.copy', component: () => import('./declarecustoms/component/copy-declare-customs.vue'),
                },  
                {
                    path: 'productelement', meta: { title: 'app.CustomsDeclarationElement.Element', access: ['RIMS.DeclareCustoms.Information'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.productelement', component: () => import('./declarecustoms/component/declaration-element.vue'),
                },   
                {
                    path: 'info', meta: { title: 'app.DeclareCustoms.info', access: ['RIMS.DeclareCustoms.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.info', component: () => import('./declarecustoms/component/edit-declare-customsinfo.vue'),
                }, 
                {
                    path: 'otherinfo', meta: { title: 'app.DeclareCustoms.OtherInfo', access: ['RIMS.DeclareCustoms.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.otherinfo', component: () => import('./declarecustoms/component/edit-declare-customsotherinfo.vue'),
                },   
                {
                    path: 'infoall', meta: { title: 'app.DeclareCustoms.InfoAll', access: ['RIMS.DeclareCustoms.Edit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'declarecustoms.infoall', component: () => import('./declarecustoms/component/edit-infoall.vue'),
                },            
            ]
        },  
        {
            path: 'factorycost', meta: { title: 'app.FactoryCost', access: ['RIMS.FactoryCost'], icon: '', defaultChild: 'factorycost.list' },
            name: 'factorycost', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.FactoryCost', access: ['RIMS.FactoryCost'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factorycost.list', component: () => import('./factorycost/index.vue'),
                },
                {
                    path: 'registration', meta: { title: 'app.FactoryCost.Registration', access: ['RIMS.FactoryCost.Registration'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factorycost.registration', component: () => import('./factorycost/component/registration.vue'),
                },
                {
                    path: 'detail', meta: { title: 'app.FactoryCost.Detail', access: ['RIMS.FactoryCost.Detail'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'factorycost.detail', component: () => import('./factorycost/component/detail-factorycost.vue'),
                },
                    
            ]
        },    
        {
            path: 'logisticscost', meta: { title: 'app.LogisticsCost', access: ['RIMS.LogisticsCost'], icon: '', defaultChild: 'logisticscost.list' },
            name: 'logisticscost', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.LogisticsCost', access: ['RIMS.LogisticsCost'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logisticscost.list', component: () => import('./logisticscost/index.vue'),
                },
                {
                    path: 'registration', meta: { title: 'app.FactoryCost.Registration', access: ['RIMS.LogisticsCost.Registration'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logisticsCost.registration', component: () => import('./logisticscost/component/registration.vue'),
                },
                {
                    path: 'detail', meta: { title: 'app.FactoryCost.Detail', access: ['RIMS.LogisticsCost.Detail'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'logisticscost.detail', component: () => import('./logisticscost/component/detail-logisticscost.vue'),
                },
                    
            ]
        },  
    ]
}
]

export default appRouters